import { render, staticRenderFns } from "./ProjectListScreen.vue?vue&type=template&id=c1615d32"
import script from "./ProjectListScreen.vue?vue&type=script&lang=js"
export * from "./ProjectListScreen.vue?vue&type=script&lang=js"
import style0 from "./ProjectListScreen.vue?vue&type=style&index=0&id=c1615d32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports